import { render } from "./Mask.vue?vue&type=template&id=25a95c4e"
import script from "./Mask.vue?vue&type=script&lang=js"
export * from "./Mask.vue?vue&type=script&lang=js"

import "./Mask.vue?vue&type=style&index=0&id=25a95c4e&lang=scss"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__